<script setup>
    import { defineExpose, defineEmits, ref } from 'vue';
    import { useConsultationWebStore } from '@/stores/consultation/consultationWebStore';
    import { inject } from 'vue';
    import { getCurrentInstance } from 'vue';

    import { useCommonStore } from '@/stores/common/commonStore';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import utils from '@/commonProject/helpers/utils';
    import i18n from '@/common/i18n';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');
    // web相談ストア
    const consultationWebStore = useConsultationWebStore();
    // Web相談詳細情報レスポンス
    const webdtlResponce = ref({});
    // Web相談PK
    const webCngPk = ref('');
    // Web相談登録入力(Tms型)アンケート内容情報レスポンス
    let webCngTmsFormAttrResponce = ref([]);
    // Web相談登録入力(Tms型)アンケート回答情報レスポンス
    let webCngTmsFormDataResponce = ref([]);
    // Web相談登録入力(Tms型)アンケート回答結果
    let webCngTmsFormAttrAnswer = ref([]);
    // モーダルフラグ
    const detailTmsDispFlg = ref('');
    const finishConfirmDispFlg = ref('');
    const finishCompleteDispFlg = ref('');

    const languageStore = useLanguageStore();

    const app = getCurrentInstance();

    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    const commonStore = useCommonStore();
    
    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    /**
     * 初期処理 親画面から利用可能関数
     * @param WebCngPk Web相談PK
     */
    async function setInfo(WebCngPk) {
        // モーダル側で保持しているデータの初期化
        consultationWebStore.messageList = {};

        webdtlResponce.value = {};
        webCngTmsFormAttrAnswer.value.splice(0);
        webCngTmsFormAttrResponce.value.splice(0);
        webCngPk.value = '';
        webCngPk.value = WebCngPk;
        // モーダルフラグ設定
        detailTmsDispFlg.value = 'block';
        finishConfirmDispFlg.value = '';
        finishCompleteDispFlg.value = '';
        // Web相談詳細情報取得
        await getRegistrationInformation(WebCngPk);
        // アンケート表示
        await getWebCngTmsFormAttr();
        // Web相談メッセージ一覧取得
        await getMessageList(WebCngPk);
        // Web相談メッセージ既読登録
        await registerAlreadyRead(WebCngPk);

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalWebConsultationDetailType1 .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }

    /**
     * 再表示
     */
    async function reDisplay() {
        await setInfo(webCngPk.value);
    }
    defineExpose({
        setInfo,
        reDisplay,
    });

    /**
     * アンケート表示処理
     */
    async function getWebCngTmsFormAttr() {
        // Web相談登録入力(Tms型)アンケート内容
        webCngTmsFormAttrResponce.value = consultationWebStore.webCngTmsFormAttrResponce;
        // Web相談登録入力(Tms型)アンケート一時保存情報
        webCngTmsFormDataResponce.value = consultationWebStore.webCngTmsFormDataResponce;
        // 初期表示時アンケート回答情報作成
        getWebCngTmsFormAttrAnswer();
    }

    /**
     * 初期表示時アンケート回答情報作成処理
     */
    async function getWebCngTmsFormAttrAnswer() {
        if (!utils.isNullEmptyArray(webCngTmsFormAttrResponce.value)) {
            for (const formAttr of webCngTmsFormAttrResponce.value) {
                // プルダウン、チェックボックス、ラジオボタンの選択肢を作成する。
                let ChoicesArr = [];
                if (!utils.isNullEmptyArray(formAttr.Choices)) {
                    for (const choice of formAttr.Choices) {
                        let obj = {};

                        const index = choice.indexOf(':');

                        // コロンの区切りIDと名称の区切り文字が存在するか判定する。
                        if (index !== -1) {
                            // コロンの区切り文字が存在する場合は、存在する座標が返却される。
                            // 選択肢のID部と名称部を分離する。
                            obj = {
                                id: choice.substr(0, index), // コロンの位置までを抽出しIDとして設定する。
                                name: choice.substr(index + 1), // コロンの座標の次の文字列以降を全て名称として抽出する。
                                value: choice,
                            };
                        } else {
                            // コロンの区切り文字ば存在しない場合は-1が返る。
                            // APIの取得情報をそのまま格納する。
                            obj = {
                                id: choice,
                                name: choice,
                                value: choice,
                            };
                        }

                        // 選択肢の情報を格納する。
                        ChoicesArr.push(obj);
                    }
                }

                const a = {
                    Id: formAttr.Id,
                    No: formAttr.No,
                    Nm: formAttr.Nm,
                    Type: formAttr.Type,
                    Required: formAttr.Required,
                    Explain: formAttr.Explain,
                    Choices: ChoicesArr,
                    Answer: null,
                };

                webCngTmsFormAttrAnswer.value.push(a);

                // ***** 回答データを復元する - ここから - ***** //
                if (!utils.isNullEmptyArray(webCngTmsFormDataResponce.value)) {
                    for (const answeredData of webCngTmsFormDataResponce.value) {
                        // アンケートの各設問に回答が存在するか判定する。
                        if (!utils.isNullEmptyArray(answeredData.Values)) {
                            // 回答が存在する場合のみ実行する。
                            for (let j = 0; j < webCngTmsFormAttrAnswer.value.length; j++) {
                                let answerFormModal = webCngTmsFormAttrAnswer.value[j];
                                if (answeredData.Id === answerFormModal.Id) {
                                    switch (answerFormModal.Type) {
                                        case '01':
                                        case '02':
                                            answerFormModal.Answer = [];
                                            for (const value of answeredData.Values) {
                                                for (const choice of answerFormModal.Choices) {
                                                    if (value === choice.id) {
                                                        answerFormModal.Answer.push(choice.name);
                                                    }
                                                }
                                            }
                                            break;
                                        default:
                                            answerFormModal.Answer = '';
                                            answerFormModal.Answer = answeredData.Values[0];
                                            break;
                                    }
                                }
                            }
                        }
                    }
                }
                // ***** 回答データを復元する - ここまで - ***** //
            }
        }
    }

    /**
     * Web相談詳細情報取得処理
     * @param WebCngPk Web相談PK
     */
    async function getRegistrationInformation(WebCngPk) {
        const queryParam = {
            Lang: languageStore.getLanguageValue,
            WebCngPk: WebCngPk,
        };
        const response = await consultationWebStore.getRegistrationInformation(API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * Web相談メッセージ一覧取得処理
     * @param WebCngPk Web相談PK
     */
    async function getMessageList(WebCngPk) {
        const requestBody = {
            Lang: languageStore.getLanguageValue,
            WebCngPk: WebCngPk,
        };
        const response = await consultationWebStore.getMessageList(API_URL, requestBody);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * Web相談メッセージ既読登録処理
     * @param WebCngPk Web相談PK
     */
    async function registerAlreadyRead(WebCngPk) {
        if (consultationWebStore.messageList.WebCngMsgs.length !== 0) {
            for (let i = 0; i < consultationWebStore.messageList.WebCngMsgs.length; i++) {
                // メッセージタイプがカウンセラーで未読のメッセージを既読登録する。
                if (consultationWebStore.messageList.WebCngMsgs[i].WebCngMsgType === '2' && !consultationWebStore.messageList.WebCngMsgs[i].WebCngReaded) {
                    const requestBody = {
                        WebCngPk: WebCngPk,
                        WebCngMsgPk: consultationWebStore.messageList.WebCngMsgs[i].WebCngMsgPk,
                        WebCngDeleted: consultationWebStore.messageList.WebCngMsgs[i].WebCngDeleted,
                    };
                    const response = await consultationWebStore.registerAlreadyRead(API_URL, requestBody);
                    if (!response.success) {
                        messageDialog('error', response.errorMessage);
                        if (response.redirect) {
                            location.href = response.redirectUrl;
                        }
                        return;
                    }
                }
            }
        }
    }

    /**
     * Web相談メッセージ登録処理
     * @param WebCngMsgMode Web相談メッセージ種別("1"：正式、"2"：一時保存)
     */
    async function registerMessage(WebCngMsgMode) {
        // メッセージ入力欄が未入力の場合。
        if (utils.isNullEmpty(consultationWebStore.messageList.WebCngDraftMsg)) {
            messageDialog('error', i18n.global.t('consultationWebDetailTms.message.message1'));
            return;
        } else {
            // 文字数が超過している場合。
            if (utils.checkLengthOfLongString(consultationWebStore.messageList.WebCngDraftMsg)) {
                messageDialog('error', i18n.global.t('consultationWebDetailTms.message.message2'));
                return;
            }
        }
        
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        const requestBody = {
            WebCngPk: webCngPk.value,
            WebCngMsgMode: WebCngMsgMode,
            WebCngMsg: consultationWebStore.messageList.WebCngDraftMsg,
        };
        const response = await consultationWebStore.registerMessage(API_URL, requestBody);
        if (response.success) {
            reDisplay();
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * Web相談詳細モーダル「相談終了」
     */
    function nextModal() {
        detailTmsDispFlg.value = '';
        finishConfirmDispFlg.value = 'block';
    }

    /**
     * Web相談終了確認モーダル「いいえ」
     */
    function backModal() {
        detailTmsDispFlg.value = 'block';
        finishConfirmDispFlg.value = '';
    }

    /**
     * Web相談終了確認モーダル「はい」
     * @param WebCngOpeMode Web相談操作種別("1"：相談登録(正式)、"2"：相談登録(一時保存)、"3"：一時保存削除、"4"：相談終了)
     */
    async function register(WebCngOpeMode) {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        const requestBody = {
            WebCngOpeMode: WebCngOpeMode,
            WebCngPk: webCngPk.value,
            NoticeHistPk: consultationWebStore.webdtlResponce.NoticeHistPk,
            WebCngArmSubj: consultationWebStore.webdtlResponce.WebCngArmSubj,
            WebCngArmIsuPk: consultationWebStore.webdtlResponce.WebCngArmIsuPk,
            WebCngArmCont: consultationWebStore.webdtlResponce.WebCngArmCont,
            WebCngTmsCat1Pk: consultationWebStore.webdtlResponce.WebCngTmsCat1Pk,
            WebCngTmsCat2Pk: consultationWebStore.webdtlResponce.WebCngTmsCat2Pk,
            WebCngTmsCat3Pk: consultationWebStore.webdtlResponce.WebCngTmsCat3Pk,
            WebCngTmsFormPk: consultationWebStore.webdtlResponce.WebCngTmsFormPk,
            WebCngTmsFormData: consultationWebStore.webdtlResponce.WebCngTmsFormData,
        };
        const response = await consultationWebStore.registerConsultationWeb(API_URL, requestBody);
        if (response.success) {
            finishConfirmDispFlg.value = '';
            finishCompleteDispFlg.value = 'block';
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }

    /**
     * 親画面で実装必須関数
     */
    const emit = defineEmits(['detailTmsModal:cancel', 'detailTmsModal:cancelUpdate', 'detailTmsModal:regist', 'detailTmsModal:OpenSuerveyApply']);
    function cancel() {
        // 親画面のキャンセル処理を呼び出す
        emit('detailTmsModal:cancel');
    }
    function cancelUpdate() {
        // 親画面の更新キャンセル処理を呼び出す
        emit('detailTmsModal:cancelUpdate');
    }
    function OpenSuerveyApply() {
        emit('detailTmsModal:OpenSuerveyApply');
    }
</script>
<template>
    <article id="modalWebConsultationDetailType1" class="modal" :style="{ display: detailTmsDispFlg }">
        <h3>{{ $t('consultationWebDetailTms.parts.modalTitle1') }}</h3>
        <section class="modalContents">
            <section class="form">
                <div class="dlGroup">
                    <dl id="counselingStartDate">
                        <!--相談開始日時-->
                        <dt>
                            <span>{{ $t('consultationWebDetailTms.parts.dl3') }}</span>
                        </dt>
                        <dd>
                            <span>{{ consultationWebStore.webdtlResponce.WebCngOpenDt }}</span>
                        </dd>
                    </dl>
                    <dl id="counselingEndDate">
                        <!--相談終了日時とステータス-->
                        <dt v-if="consultationWebStore.webdtlResponce.WebCngStatus === '3'">
                            <!--Web相談ステータスが「相談終了」の場合のみ表示する-->
                            <span>{{ $t('consultationWebDetailTms.parts.dl4') }}</span>
                        </dt>
                        <dd v-if="consultationWebStore.webdtlResponce.WebCngStatus === '3'">
                            <!--Web相談ステータスが「相談終了」の場合のみ表示する-->
                            <span>{{ consultationWebStore.webdtlResponce.WebCngCloseDt }}</span>
                        </dd>
                        <dd id="counselingStatus">
                            <template v-if="consultationWebStore.webdtlResponce.WebCngStatus === '2'">
                                <!--Web相談ステータスが「相談中」の場合-->
                                <!--「相談中」を表示する-->
                                <span id="complete">{{ $t('consultationWebDetailTms.parts.dl1') }}</span>
                            </template>
                            <template v-else-if="consultationWebStore.webdtlResponce.WebCngStatus === '3'">
                                <!--Web相談ステータスが「相談終了」の場合-->
                                <template v-if="consultationWebStore.webdtlResponce.QuestionStatus !== '2'">
                                    <!--アンケートステータスが「未回答」-->
                                    <!--「相談終了」を表示する-->
                                    <span id="complete">{{ $t('consultationWebDetailTms.parts.dl2') }}</span>
                                </template>
                                <template v-else>
                                    <!--アンケートステータスが「未回答」-->
                                    <!--「相談後アンケート回答済み」を表示する-->
                                    <span id="complete">{{ $t('consultationWebDetailTms.parts.dl2') }}</span>
                                    <span id="complete">{{ $t('consultationWebDetailTms.parts.dl5') }}</span>
                                </template>
                            </template>
                        </dd>
                    </dl>
                </div>
                <!-- 種別 -->
                <dl class="line">
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebDetailTms.parts.dl6') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <span>{{ consultationWebStore.webdtlResponce.WebCngTmsCat1Nm }}</span>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- 分類1 -->
                <dl class="line">
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebDetailTms.parts.dl7') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <span>{{ consultationWebStore.webdtlResponce.WebCngTmsCat2Nm }}</span>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- 分類2 -->
                <dl class="line">
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebDetailTms.parts.dl8') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="formInput">
                            <li>
                                <span>{{ consultationWebStore.webdtlResponce.WebCngTmsCat3Nm }}</span>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <!-- アンケートと相談内容 -->
                <dl>
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebDetailTms.parts.dl9') }}{{ $t('consultationWebDetailTms.parts.dl10') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <table class="servey" style="width: 100%">
                            <tbody>
                                <tr v-for="(FormAttr, index) in webCngTmsFormAttrAnswer" :key="index">
                                    <template v-if="FormAttr.Type === '09'">
                                        <!--見出しが選択されている場合-->
                                        <td>
                                            <span>{{ FormAttr.Nm }}</span>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <!--見出し以外のパターンの項目が選択されている場合-->
                                        <td>
                                            <span>{{ FormAttr.No }}</span>
                                        </td>
                                        <td>
                                            <span>{{ FormAttr.Nm }}</span>
                                        </td>
                                        <td>
                                            <template v-if="FormAttr.Type === '01'">
                                                <!--ラジオボタンで回答した結果を表示する-->
                                                <template v-if="!utils.isNullEmptyArray(FormAttr.Answer)">
                                                    <ul class="blockInfoBox">
                                                        <li v-for="(data, index2) in FormAttr.Answer" :key="index + '-' + index2">
                                                            <span>{{ data }}</span>
                                                        </li>
                                                    </ul>
                                                </template>
                                            </template>
                                            <template v-else-if="FormAttr.Type === '02'">
                                                <!--チェックボックスで回答した結果を表示する-->
                                                <template v-if="!utils.isNullEmptyArray(FormAttr.Answer)">
                                                    <ul class="blockInfoBox">
                                                        <li v-for="(data, index2) in FormAttr.Answer" :key="index + '-' + index2">
                                                            <span>{{ data }}</span>
                                                        </li>
                                                    </ul>
                                                </template>
                                            </template>
                                            <template v-else-if="FormAttr.Type === '04'">
                                                <!--テキストボックスで回答した結果を表示する-->
                                                <template v-if="!utils.isNullEmpty(FormAttr.Answer)">
                                                    <span>{{ FormAttr.Answer }}</span>
                                                </template>
                                            </template>
                                            <template v-else-if="FormAttr.Type === '05'">
                                                <!--テキストエリアで回答した結果を表示する-->
                                                <template v-if="!utils.isNullEmpty(FormAttr.Answer)">
                                                    <span>{{ FormAttr.Answer }}</span>
                                                </template>
                                            </template>
                                        </td>
                                        <td>
                                            <span>{{ FormAttr.Explain }}</span>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                </dl>
                <!--Web相談の詳細情報-->
                <hr class="line" />
                <dl class="line">
                    <!--返信-->
                    <dt>
                        <ul class="formLabel">
                            <li>
                                <label>{{ $t('consultationWebDetailTms.parts.dl11') }}</label>
                            </li>
                        </ul>
                    </dt>
                    <dd>
                        <ul class="contactHistoryBlock">
                            <template v-for="(massage, index) in consultationWebStore.messageList.WebCngMsgs" :key="index">
                                <li :class="{ counselor: massage.WebCngMsgType === '2' }">
                                    <ul>
                                        <li>
                                            <span>
                                                {{ commonStore.getConvertDictionary('WebCngMsgType', String(massage.WebCngMsgType), languageStore.getLanguageValue) }}
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{ massage.WebCngMsgSendDt }}</span>
                                        </li>
                                    </ul>
                                    <div class="message">
                                        <template v-if="massage.WebCngDeleted">
                                            <p>{{ $t('common.parts.messageDeleted') }}</p>
                                        </template>
                                        <template v-else>
                                            <p>{{ massage.WebCngMsg }}</p>
                                        </template>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </dd>
                </dl>
                <dl class="line" v-if="consultationWebStore.webdtlResponce.WebCngStatus !== '3'">
                    <!--新しい返信-->
                    <dt>
                        <ul class="headerBlock">
                            <li>
                                <span>{{ $t('consultationWebDetailTms.parts.dl12') }}</span>
                            </li>
                        </ul>
                    </dt>
                    <dd id="newMessage">
                        <ul class="formInput">
                            <li>
                                <div id="textArea">
                                    <textarea style="border-radius: 8px; height: 140px;" v-model="consultationWebStore.messageList.WebCngDraftMsg" />
                                </div>
                            </li>
                        </ul>
                        <ul class="btnArea right">
                            <li>
                                <button type="button" class="btnSecondary" v-if="consultationWebStore.webdtlResponce.WebCngStatus !== '3'" @click="registerMessage('2')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebDetailTms.parts.modalButton1') }}</button>
                            </li>
                            <li>
                                <button type="button" class="btnPrimary" v-if="consultationWebStore.webdtlResponce.WebCngStatus !== '3'" @click="registerMessage('1')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebDetailTms.parts.modalButton2') }}</button>
                            </li>
                        </ul>
                    </dd>
                </dl>
                <ul class="btnArea center" v-if="consultationWebStore.webdtlResponce.WebCngStatus !== '3'">
                    <li>
                        <button type="button" class="btnSecondary" @click="nextModal">{{ $t('consultationWebDetailTms.parts.modalButton3') }}</button>
                    </li>
                </ul>
                <ul class="btnArea center" v-if="consultationWebStore.webdtlResponce.WebCngStatus === '3' && consultationWebStore.webdtlResponce.QuestionStatus === '1'">
                    <li>
                        <button type="button" class="btnSecondary wide" @click="OpenSuerveyApply()">{{ $t('consultationWebDetailTms.parts.modalButton4') }}</button>
                    </li>
                </ul>
            </section>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="cancel">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalWebConsultationFinishCheck" class="modal small" :style="{ display: finishConfirmDispFlg }">
        <!--Web相談終了確認モーダル-->
        <p class="textCenter" style="margin-bottom: 20px">{{ $t('consultationWebDetailTms.parts.modalTitle1') }}</p>
        <p class="textCenter" style="font-size: 16px">{{ $t('consultationWebFinishConfirm.parts.modalInformation1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="backModal">{{ $t('consultationWebFinishConfirm.parts.modalButton1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="register('4')" :disabled="disabledStore.isDisabled">{{ $t('consultationWebFinishConfirm.parts.modalButton2') }}</button>
                </li>
            </ul>
        </section>
    </article>
    <article id="modalWebConsultationFinishComplete" class="modal small" :style="{ display: finishCompleteDispFlg }">
        <!--Web相談終了完了モーダル-->
        <p class="textCenter">{{ $t('consultationWebFinishComplete.parts.modalTitle1') }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="cancelUpdate()">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
<style></style>
